import Vue from 'vue';
import { getTime } from 'date-fns';

export default new Vue({
  data() {
    return {
      id: 0,
      items: [],
    };
  },

  methods: {
    add(text, type = 'info', time = 5) {
      const id = ++this.id;
      const notification = {
        id: id,
        timestamp: getTime(new Date()),
        text,
        type,
      };
      const size = this.items.length;

      // Return if text is empty
      if (!notification.text) {
        return;
      }

      // Return if the prev notification is same as new notification
      // We do not want to flood the UI with notification of a repetitive action
      // Sometimes it could be a UI glitch too
      if (size && this.items[size - 1].text === notification.text) {
        return this.items[size - 1].id;
      }

      this.items.push(notification);

      setTimeout(() => {
        this.remove(id);
      }, time * 1000);
      return id;
    },

    remove(id) {
      const index = this.items.findIndex(item => item.id === id);
      if (index > -1) {
        this.items.splice(index, 1);
      }
    },

    clear() {
      this.items = [];
    },
  },
});
